import React from 'react';
import { Route } from 'react-router-dom';

import HomeInicio from '../../Home/Inicio/HomeInicio';

const HomeRoutes = () => {
  return (
    <>
      <Route path="home/inicio" element={<HomeInicio />} />
    </>
  );
};

export default HomeRoutes;
